import "swiper/css";

import React, { useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { ToolsForMarketing } from "../../../constants/tools-for-marketing.contant";

type Props = {};

function SiteSalesSupportComponent({}: Props) {
  const { t } = useTranslation();
  const swiperRef = useRef();

  const [data, setData] = useState(ToolsForMarketing);

  const onSlideChange = (item: any) => {
    const dataTemp = data;

    dataTemp.forEach((temp: any) => {
      temp.active = false;
    });

    dataTemp[item.activeIndex].active = true;

    setData(JSON.parse(JSON.stringify(dataTemp)));
  };

  const switchSlide = (index: number) => {
    (swiperRef.current as any).slideTo(index);
  };

  return (
    <section id="sale-support">
      <Container>
        <Row className="py-5">
          <Col>
            <Row>
              <Col className="d-flex justify-content-center text-center">
                <h1 className="font-sofiaSans fw-bold">
                  {t("home/SiteSalesSupport/title")}
                </h1>
              </Col>
            </Row>
            <Row>
              <Col>
                <Row>
                  {data.map((i, el) => {
                    return (
                      <Col
                        className="cursor-pointer"
                        lg="4"
                        md="4"
                        sm="12"
                        key={i.id}
                        onClick={() => {
                          switchSlide(el);
                        }}
                      >
                        <Row className="p-2">
                          <Col
                            className={`${
                              i.active ? "bg-tenColor" : ""
                            } p-3 px-lg-5 rounded-3`}
                          >
                            <Row>
                              <Col>
                                <h3>{t(i.title)}</h3>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <p className="font-sofiaSans">
                                  {t(i.description)}
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
            <Row>
              <Col className="d-flex justify-content-center ">
                <Swiper
                  style={{ boxShadow: "0px 20px 32px 0px rgba(0, 0, 0, 0.12)" }}
                  onSwiper={(swiper) => {
                    (swiperRef.current as any) = swiper;
                  }}
                  modules={[Autoplay]}
                  onSlideChange={onSlideChange}
                  autoplay={true}
                >
                  {data.map((i, el) => {
                    return (
                      <SwiperSlide key={i.id}>
                        <img
                          crossOrigin="anonymous"
                          src={i.image}
                          className="w-100 h-100 tw-rounded-md md:tw-rounded-xl "
                        />
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SiteSalesSupportComponent;
